import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslationsLibService } from '@nutricontrol/app360-shared';

@Component({
  selector: 'app-configuration-type-selector',
  templateUrl: './configuration-type-selector.component.html',
  styleUrls: ['./configuration-type-selector.component.scss'],
})
export class ConfigurationTypeSelectorComponent {
  @Input() formGroup: FormGroup;
  @Output() configurationTypeChanged = new EventEmitter<void>();

  constructor(public translationLib: TranslationsLibService) {}
  onConfigurationTypeChange() {
    this.configurationTypeChanged.emit();
  }
}
